const ImageCache = require("./ImageCache");
const Async = require("./Async");

const preloadOne = function(src, crossOrigin, cb) {
	return ImageCache.src(src, crossOrigin, cb);
};

// Callback is called with null if no errors, else returns array of all errors
// like what Async.parallel does.
const preloadMany = function(srcList, crossOrigin, cb) {
	cb = cb || (() => {});
	const loadCbs = srcList.map(src => {
		return imageCb => preloadOne(src, crossOrigin, imageCb);
	});
	Async.parallel(loadCbs, errList => {
		return cb(errList.filter(Boolean).length ? errList : null);
	});
};

const preload = function(src, crossOrigin, cb) {
	if (Array.isArray(src)) {
		preloadMany(src, crossOrigin, cb);
	} else {
		preloadOne(src, crossOrigin, cb);
	}
};

module.exports = {
	preload,
};
